import { render, staticRenderFns } from "./CategoryFeaturesBlocks.vue?vue&type=template&id=1767be28"
import script from "./CategoryFeaturesBlocks.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryFeaturesBlocks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CategoryFeaturesBlocks.vue?vue&type=style&index=0&id=1767be28&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButton: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/components/ui/UiButton.vue').default})
